import React, { useState, useEffect } from 'react';

import * as dateFns from 'date-fns';
import { Stack, Select, MenuItem, FormControl, InputLabel } from '@mui/material';

// Custom date selector without the day component
const MonthYearSelector = ({ value, onChange }) => {
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState('');

  useEffect(() => {
    const date = value ?? new Date();
    const month = dateFns.format(date, 'MMMM');
    const year = dateFns.format(date, 'yyyy');
    setSelectedMonth(month);
    setSelectedYear(year);
  }, [value]);

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
    const selectedDate = new Date(selectedYear, months.indexOf(event.target.value));
    onChange(selectedDate);
  };

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
    const selectedDate = new Date(event.target.value, months.indexOf(selectedMonth));
    onChange(selectedDate);
  };

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const startYear = Number(dateFns.format(new Date(), 'yyyy'));
  const endYear = startYear + 80;
  const years = [
    startYear,
    ...Array.from({ length: endYear - startYear }, (_, index) => startYear + index + 1),
  ];

  return (
    <Stack direction="row" spacing={2}>
      <FormControl size="small" fullWidth>
        <InputLabel id="type-label">Month</InputLabel>
        <Select value={selectedMonth} onChange={handleMonthChange} label="Month">
          {months.map((month, index) => (
            <MenuItem key={index} value={month}>
              {month}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" fullWidth>
        <InputLabel id="type-label">Year</InputLabel>
        <Select value={selectedYear} onChange={handleYearChange} label="Year">
          {years.map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
};

export default MonthYearSelector;
